'use strict';
'use client';
import { j as r } from "../../external/react/jsx-runtime.js";
import s from "../../external/classnames/index.js";
import { useTheme as b } from "../Provider/index.js";
const k = ({
  className: o,
  options: a,
  name: d,
  onChange: n,
  value: c,
  ...u
}) => {
  const { isMoshy: i } = b(), x = (e) => {
    n && n(e);
  }, l = (e, t) => e || t ? "border-white" : i ? "border-blue-dark" : "border-green-faint-dark", f = (e, t) => e || t ? "text-white" : i ? "text-blue-dark" : "text-green-faint-dark", h = (e) => e ? i ? "bg-blue-dark" : "bg-green-faint-dark" : "", m = () => i ? "hover:bg-blue-dark" : "hover:bg-green-faint-dark", g = (e) => e ? "text-white" : "text-grey-400";
  return /* @__PURE__ */ r.jsx("div", { className: s("flex flex-col gap-2", o), ...u, children: a.map((e) => {
    const t = c === e.value;
    return /* @__PURE__ */ r.jsxs(
      "label",
      {
        className: s(
          "h-14 relative rounded-lg cursor-pointer w-full transition-colors group",
          h(t),
          m()
        ),
        htmlFor: e.id,
        children: [
          /* @__PURE__ */ r.jsx(
            "input",
            {
              type: "radio",
              id: e.id,
              name: d,
              value: e.value,
              checked: t,
              onChange: x,
              className: "sr-only"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "div",
            {
              className: s(
                "absolute border border-solid inset-0 pointer-events-none rounded-lg transition-colors",
                t ? l(t, !1) : "border-grey-300"
              )
            }
          ),
          /* @__PURE__ */ r.jsx("div", { className: "flex flex-row items-center relative size-full", children: /* @__PURE__ */ r.jsxs("div", { className: "box-border content-stretch flex flex-row gap-3 h-14 items-center justify-start p-4 relative w-full", children: [
            /* @__PURE__ */ r.jsxs("div", { className: "relative shrink-0 size-6", children: [
              /* @__PURE__ */ r.jsx(
                "div",
                {
                  className: s(
                    "absolute border border-solid inset-0 pointer-events-none rounded-sm transition-colors",
                    l(
                      t,
                      !1
                    ),
                    "group-hover:border-white"
                  )
                }
              ),
              /* @__PURE__ */ r.jsx("div", { className: "flex flex-row items-center justify-center relative size-full", children: /* @__PURE__ */ r.jsx("div", { className: "box-border content-stretch flex flex-row gap-2 items-center justify-center p-4 relative size-6", children: /* @__PURE__ */ r.jsx(
                "div",
                {
                  className: s(
                    "font-demi leading-none not-italic relative shrink-0 text-base text-left text-nowrap tracking-tight transition-colors",
                    f(
                      t,
                      !1
                    ),
                    "group-hover:text-white"
                  ),
                  children: /* @__PURE__ */ r.jsx("p", { className: "block leading-[1.35] whitespace-pre", children: e.number })
                }
              ) }) })
            ] }),
            /* @__PURE__ */ r.jsx(
              "div",
              {
                className: s(
                  "basis-0 font-book grow leading-none min-h-px min-w-px not-italic relative shrink-0 text-base text-left tracking-tight transition-colors",
                  g(t),
                  "group-hover:text-white"
                ),
                children: /* @__PURE__ */ r.jsx("p", { className: "block leading-[1.35]", children: e.label })
              }
            )
          ] }) })
        ]
      },
      e.id
    );
  }) });
};
export {
  k as NumberedRadioGroup,
  k as default
};
